// Celda de nombre de las listas con ciclo de vida: nombre y un detalle, cada uno en una línea truncada.
import { cn } from '@/lib/cn';

export interface LifecycleNameCellProps {
    name: string;
    /** El renglón chico de abajo; se omite si no hay. */
    detail?: string | null;
    /** Datos que no se pintan pero van al `title`, junto con el nombre y el detalle. */
    extra?: readonly (string | null | undefined)[];
    /** Atenuada cuando el registro ya no aplica (pausado, vencido…). */
    dimmed?: boolean;
    /** Mini insignia en línea con el nombre, como «Sistema». */
    badge?: string;
    /** Nombre en fuente monoespaciada, para códigos que se teclean. */
    mono?: boolean;
}

const NO_NAME = 'Sin nombre';

export function LifecycleNameCell({
    name,
    detail,
    extra = [],
    dimmed = false,
    badge,
    mono = false,
}: LifecycleNameCellProps) {
    const label = name || NO_NAME;
    const title = [label, detail, ...extra].filter(Boolean).join('\n');
    return (
        <div className={cn('min-w-0', dimmed && 'opacity-65')} title={title}>
            <div className="flex min-w-0 items-center gap-1.5">
                <div
                    className={cn(
                        'min-w-0 truncate font-semibold leading-[1.3] text-foreground',
                        mono && 'font-mono',
                    )}
                >
                    {label}
                </div>
                {badge ? (
                    <span className="flex-none rounded border border-border px-1 text-[9px] leading-[1.4] text-muted-foreground">
                        {badge}
                    </span>
                ) : null}
            </div>
            {detail ? (
                <div className="mt-0.5 truncate text-[10px] leading-[1.3] text-muted-foreground">
                    {detail}
                </div>
            ) : null}
        </div>
    );
}
